import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { GiftBoxResponse, GiftCouponStatus } from '@models/gift';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    giftBox: GiftBoxResponse;
}

function GiftItem({ giftBox }:Props) {
    const { giftItemType, giftCoupon, giftCard } = giftBox;
    const { t } = useTranslation('gift');

    const getCouponStatusKey = (status: string) => {
        const statusMap: Record<string, string> = {
            ISSUED: 'issued',
            USED: 'used',
            CANCELED: 'canceled',
            EXPIRED: 'expired',
            CANCEL_FAILED: 'cancelFailed',
            SENT: 'sent',
            SEND_FAILED: 'sendFailed',
            OFF_USED: 'offUsed',
            DEACTIVATED: 'deactivated',
        };
        return `couponStatus.${statusMap[status] || status.toLowerCase()}`;
    };

    return (
        <Container fullWidth align='center'>

            <Text size='2xl' fontWeight='medium'
                color={colors.gray7}>
                {giftCoupon?.name || giftCard?.name}
            </Text>

            {giftItemType === 'PRODUCT' && (
                <Expires spacing={4}>
                    <Text size='lg' color={colors.gray6} fontWeight='bold'>
                        {t('giftReceived.validPeriod')}
                    </Text>
                    <Text color={colors.gray6}>
                        {t('giftReceived.validUntil', { date: '2025.05.24. 23:59' })}
                    </Text>
                </Expires>
            )}
            {giftCoupon && (
                <Fragment>
                    <Item>
                        <Image src='/dummy/img_4.png'
                            width={106}
                            height={106}
                            alt={t('giftReceived.productImageAlt')} />
                        {giftCoupon.status !== GiftCouponStatus.DEACTIVATED && (
                            <StatusBadge>
                                {t(getCouponStatusKey(giftCoupon.status))}
                            </StatusBadge>
                        )}
                    </Item>
                    <Text size='3xl' fontWeight='bold'>5,500{t('item.priceUnit')}</Text>
                </Fragment>
            )}
            {giftCard && (
                <Card src='/dummy/img_5.png'
                    width={200}
                    height={134}
                    alt={t('giftReceived.prepaidCardAlt')} />
            )}

        </Container>
    );
}

const Container = styled(Column)`
    padding: 20px 0;
`;

const Expires = styled(Row)`
    margin: 4px 0 20px;
`;

const Item = styled.div`
    align-items: center;
    border: 1px solid var(--color-gray2);
    border-radius: 10px;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.10);
    display: flex;
    height: 148px;
    justify-content: center;
    margin-bottom: 24px;
    overflow: hidden;
    position: relative;
    width: 148px;
`;

const StatusBadge = styled.span`
    background-color: var(--color-primary);
    color: var(--color-white);
    font-size: 12px;
    font-weight: bold;
    line-height: 20px;
    padding: 2px 8px;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 2;
`;

const Card = styled(Image)`
    border-radius: 4px;
    margin-top: 20px;
`;

export default GiftItem;
